import React from "react";
import ReactSwitch from "react-switch";

function ToggleSwitch({ handleToggle, checked, disabled }) {
  return (
    <>
      <ReactSwitch
        disabled={disabled}
        checked={checked}
        onChange={handleToggle}
        onColor="#009689"
        offColor="#CBD5E1"
        onHandleColor="#FFFFFF"
        offHandleColor="#FFFFFF"
        handleDiameter={30}
        boxShadow="0 1px 3px rgba(0,0,0,0.3)"
        activeBoxShadow="0 0 2px 3px rgba(0,150,137,0.3)"
      />
    </>
  );
}

export default ToggleSwitch;
